"use client";
import { CategoryFaq, ProdDetailFaq } from "@/services/dataTypes";
import { useState } from "react";
import { faChevronDown, FontAwesomeIcon } from "@/constants/icons";

interface Props {
    faqs: (CategoryFaq | ProdDetailFaq)[];
    categoryName?: string;
}

const CategoryFaqsAccordion = ({ faqs, categoryName }: Props) => {
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

    return (
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
            {/* Header */}
            <div className="px-6 py-4 border-b border-slate-50 flex items-center gap-2">
                <span className="w-5 h-[2px] bg-[#D61C4E] rounded-full" />
                <h3 className="text-[10px] font-black uppercase tracking-[0.3em] text-[#D61C4E]">
                    {categoryName ? `${categoryName} FAQs` : "Frequently Asked Questions"}
                </h3>
            </div>

            {/* FAQ items */}
            <div className="divide-y divide-slate-50">
                {faqs.map((faq, i) => (
                    <div key={i}>
                        <button
                            onClick={() => toggle(i)}
                            className="w-full flex items-center justify-between gap-4
                                       px-6 py-4 text-left group hover:bg-slate-50/70
                                       transition-colors duration-200"
                        >
                            <span className={`text-[13px] font-semibold leading-snug transition-colors duration-200
                                            ${openIndex === i ? "text-[#D61C4E]" : "text-slate-700 group-hover:text-slate-900"}`}>
                                {faq.question}
                            </span>
                            <span className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0
                                             border transition-all duration-300
                                             ${openIndex === i
                                    ? "bg-[#D61C4E] border-[#D61C4E] text-white rotate-180"
                                    : "bg-slate-50 border-slate-100 text-slate-400"
                                }`}>
                                <FontAwesomeIcon icon={faChevronDown} className="w-2.5 h-2.5" />
                            </span>
                        </button>

                        {/* Answer panel */}
                        <div className={`overflow-hidden transition-all duration-300 ease-in-out
                                        ${openIndex === i ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}>
                            <div className="px-6 pb-5 text-slate-500 text-[13px] leading-relaxed
                                            border-l-2 border-[#D61C4E]/20 ml-6">
                                {faq.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoryFaqsAccordion;
